<template>
  <div class="cargo-opened">
    <template v-if="getAmountOfUsers === 1">
      <i class="user-icon fas fa-user"></i>
    </template>
    <template v-if="getAmountOfUsers > 1">
      <i class="user-icon fas fa-users"></i>
    </template>
    <div class="opened-user-names">
      <div class="loaded-user" v-bind:key="'loaded_' + user.userId" v-for="user in loaded">{{ user.userName }}</div>
      <div class="opened-user" v-bind:key="'opened_' + user.userId" v-for="user in opened">{{ user.userName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenedUsers",
  props: ['opened', 'loaded'],
  computed: {
    getAmountOfUsers() {
      return (this.opened ? this.opened.length : 0) + (this.loaded ? this.loaded.length : 0)
    }
  }
}
</script>

<style lang="scss" scoped>

.cargo-opened {
  width: 100%;
  padding: 5px 15px 5px 15px;
  display: grid;
  grid-column-gap: 1rem;
  grid-template-columns: 2rem auto;
  align-items: center;
}

.opened-user:not(:last-child):after {
  content: ',';
  margin-right: 0.3rem;
}

.loaded-user:not(:last-child):after {
  content: ',';
  margin-right: 0.3rem;
}

.loaded-user {
  display: inline-block;
}

.user-icon {
  color: #0bcdf8;
  text-align: center;
}


.opened-user {
  font-weight: normal !important;
  display: inline-block;
}
</style>